import { InjectionToken } from '@angular/core';

export const TRADGINE_DATA_API_BASE_URL = new InjectionToken<string>('TRADGINE_DATA_API_BASE_URL');
